export const forms = {
  getBaseForm(extend) {
    const data = [
      {
        type: 'upload',
        label: '结项文件',
        col: '24',
        // beforeUpload: extend.upload,
        // name: 'files',
        // data: { process_base_work_number: extend.workFlowNumber.process_base_work_number },
        customRequest: extend.upload,
        id: 'activeReport',
        fileList: extend.files,
        // action: process.env.VUE_APP_API_BASE_URL + '/process/uploadProcessFile',
        disabled: extend.checkDisabled('activeReport'),
        download: extend.downLoad,
        onDelete: extend.onDelete,
        onChange: extend.onChange,
        layout: {
          labelCol: '120px'
        }
      }
    ]
    return data
  }
}
